import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { OAuthUserInfo } from '../models/oauthuserinfo.model';
import { TokenResponse } from '@openid/appauth';

const AUTH_TOKEN: string = 'auth-token';
const USERNAME: string = 'username';
const COMPANY: string = 'company';
const SS_USER_INFO = 'authorization.service.user_info';
const SS_TOKEN_RESPONSE = 'authorization.service.token_response';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  private authTokenManager: BehaviorSubject<string> = new BehaviorSubject(sessionStorage.getItem(AUTH_TOKEN));
  public authTokenChange: Observable<string> = this.authTokenManager.asObservable();

  private usernameManager: BehaviorSubject<string> = new BehaviorSubject(sessionStorage.getItem(USERNAME));
  public usernameChange: Observable<string> = this.usernameManager.asObservable();

  private userInfosManager: BehaviorSubject<string> = new BehaviorSubject(sessionStorage.getItem(SS_USER_INFO));
  public userInfosChange: Observable<string> = this.userInfosManager.asObservable();

  private tokenResponseManager: BehaviorSubject<string> = new BehaviorSubject(localStorage.getItem(SS_TOKEN_RESPONSE));
  public tokenResponseChange: Observable<string> = this.tokenResponseManager.asObservable();

  private companyManager: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public companyChange: Observable<string> = this.companyManager.asObservable();

  public setTokenResponse(tokenResponse: TokenResponse): void {
    tokenResponse && this.setAuthToken(tokenResponse.accessToken);

    localStorage.setItem(SS_TOKEN_RESPONSE, tokenResponse && JSON.stringify(tokenResponse.toJson()));
    this.tokenResponseManager.next(JSON.stringify(tokenResponse));
  }

  public getTokenResponse() {
    return JSON.parse(localStorage.getItem(SS_TOKEN_RESPONSE));
  }

  public removeTokenResponse(): void {
    localStorage.removeItem(SS_TOKEN_RESPONSE);
    this.tokenResponseManager.next(null);
  }

  public setUserInfos(info: OAuthUserInfo): void {
    info && this.setUsername(info.mail);

    sessionStorage.setItem(SS_USER_INFO, info && JSON.stringify(info));
    this.userInfosManager.next(JSON.stringify(info));
  }

  public getUserInfos(): OAuthUserInfo {
    return JSON.parse(sessionStorage.getItem(SS_USER_INFO));
  }

  public removeUserInfos(): void {
    sessionStorage.removeItem(SS_USER_INFO);
    this.userInfosManager.next(null);
  }

  public setAuthToken(token: string): void {
    sessionStorage.setItem(AUTH_TOKEN, token);
    this.authTokenManager.next(token);
  }

  public removeAuthToken(): void {
    sessionStorage.removeItem(AUTH_TOKEN);
    this.authTokenManager.next(null);
  }

  public setUsername(username: string): void {
    sessionStorage.setItem(USERNAME, username);
    this.usernameManager.next(username);
  }

  public removeUsername(): void {
    sessionStorage.removeItem(USERNAME);
    this.usernameManager.next(null);
  }

  public getUserId(): any {
    return JSON.parse(sessionStorage.getItem(SS_USER_INFO))['uid'];
  }

  public setCompany(company: string): void {
    this.companyManager.next(company);
  }

  public clearAll() {
    sessionStorage.clear();
    sessionStorage.clear();
  }

}
